module.exports = __webpack_public_path__ + "img/logo.50a5cd94.png";